import "./upload.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {keyed}                  from "@Common/react/keyed";
import {scopedState}            from "@Common/react/scoped-state";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";
import {chain}                  from "@Common/utils/fs";

import {ConfirmCancel} from "../common/confirm-cancel";
import {Header}        from "../common/header/header";
import {StepFinalize}  from "../common/step-finalize/step-finalize";

import {convertRecords}  from "./common/convert-records";
import {Step1Upload}     from "./step-1-upload/step-1-upload";
import {Step2Build}      from "./step-2-build/step-2-build";
import {Step4CassResult} from "./step-4-cass-result/step-4-cass-result";
import { AltNameTypeConfig } from "../common/alt-name-type-config";

export const Upload = ({onClose, countryCode, itemId, onCreated, onCancel, cancelLabel="Cancel", entityId, next}) => cs(
    consumeContext("apis"),
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["altNameType", (_, next) => AltNameTypeConfig({next})],
    ["data", ({altNameType}, next) => UseState({
        initValue: {
            info: {
                alternateName: {
                    type: altNameType,
                }
            },
        },
        next,
    })],
    ({confirmCancel, data, apis}) => next({
        onPassiveClose: data.value.upload && !data.value.created && confirmCancel,
        content: (
            !data.value.created ? (
                !data.value.upload ? cs(
                    keyed("step1"),
                    () => Step1Upload({
                        countryCode,
                        onNext: (upload) => {
                            stateChangeNestedValue(data, ["upload"], () => upload);
                        },
                        itemId,
                        cancelLabel,
                        onCancel,
                    })
                ) : cs(
                    ["step", (_, next) => UseState({initValue: 0, next})],
                    ({step}) => step.value === 0 ? cs(
                        keyed("step2"),
                        () => Step2Build_1({
                            countryCode,
                            data, onClose, itemId,
                            onNext: () => step.change(v=>v+1),
                        })
                    ) : cs(
                        keyed("step3"),
                        () => Step3Finalize({
                            data,
                            onBack: () => step.onChange(0),
                            onComplete: async () => {
                                const result = await apis.next.mailing.createUploadMailingList({
                                    data: convertRecords({
                                        modification: data.value.build.modification,
                                        keys: data.value.build.keys,
                                        rows: data.value.upload.rows,
                                        countryCode,
                                    }).map((r) => r.address),
                                    countryCode: countryCode ?? data.value.upload.countryCode,
                                    info: chain(
                                        data.value.info,
                                        (info) => ({
                                            ...info,
                                            listName: info.listName ?? data.value.upload.fileName.split('.')[0],
                                        }),
                                    ),
                                    entityId,
                                });


                                if (countryCode === "CA") {
                                    onCreated([result.idList]);
                                    onClose();
                                } else {
                                    stateChangeNestedValue(data, ["created"], () => ({
                                        mailingListId: result.idList,
                                    }));
                                }

                            },
                        })
                    )
                )
            ) : cs(
                keyed("step4"),
                () => Step4({
                    data: data.value,
                    onClose: () => {
                        onCreated([data.value.created.mailingListId]);
                        onClose();
                    },
                    entityId,
                })
            )
        )
    }),
);

const Step2Build_1 = ({data, itemId, onClose, countryCode, onNext}) => Step2Build({
    fileName: data.value.upload.fileName,
    columns: data.value.upload.columns,
    rows: data.value.upload.rows,
    filePath: data.value.upload.filePath,
    countryCode: countryCode ?? data.value.upload.countryCode,
    itemId,
    onClose,
    getInitData: () => ({
        keys: data.value.upload.keys,
        ...data.value.build,
        modification: {
            replaces: [],
            adds: [
                // {
                //     key: "y65",
                //     address: {
                //         "firstname": "Quan",
                //         "houseNum": "1000",
                //         "street": "FOREST PARK BLVD",
                //         "city": "Ft. Worth",
                //         "state": "TX",
                //         "zip": "43243"
                //     },
                // },
            ],
            deletes: [
                // {index: 1},
            ],
            ...data.value.build?.modification,
        },
    }),
    onNext: (build) => {
        stateChangeNestedValue(data, ["build"], () => build);
        onNext();
    },
    onBack: () => {
        stateChangeNestedValue(data, ["upload"], () => null);
    },
});

const Step3Finalize = ({onBack, onComplete, data}) => StepFinalize({
    header: Header({
        icon: require("../../../mailing-icons/listtype-upload.png"),
        title: "Finalize Address List",
        subTitle: "Name your list and approve to generate the order",
    }),
    name: "Address",
    data: scopedState(data, ["info"]),
    getDefaultListName: () => data.value.upload.fileName.split('.')[0],
    onBack, onComplete,
    xdQaName: "Finalize Address List",
});

const Step4 = ({data, entityId, onClose}) => Step4CassResult({
    created: data.created,
    fileName: data.upload.fileName,
    entityId,
    onClose,
});
